import { render } from "./SideBarDesktopCliente.vue?vue&type=template&id=35c3325f&scoped=true"
import script from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"
export * from "./SideBarDesktopCliente.vue?vue&type=script&lang=js"

import "./SideBarDesktopCliente.vue?vue&type=style&index=0&id=35c3325f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c3325f"]])

export default __exports__